import { jsx as o, Fragment as m, jsxs as l } from "react/jsx-runtime";
import { forwardRef as i } from "react";
import "./storyblok-component.mjs";
import "./storyblok-rich-text.mjs";
import { getComponent as a, getEnableFallbackComponent as c, getCustomFallbackComponent as d } from "./common.mjs";
import "./story.mjs";
const s = i(
  ({ blok: e, ...r }, p) => {
    if (!e)
      return console.error(
        "Please provide a 'blok' property to the StoryblokComponent"
      ), /* @__PURE__ */ o("div", { children: "Please provide a blok property to the StoryblokServerComponent" });
    const t = a(e.component);
    if (t)
      return /* @__PURE__ */ o(t, { ref: p, blok: e, ...r });
    if (c()) {
      const n = d();
      return n ? /* @__PURE__ */ o(n, { blok: e, ...r }) : /* @__PURE__ */ o(m, { children: /* @__PURE__ */ l("p", { children: [
        "Component could not be found for blok",
        " ",
        /* @__PURE__ */ o("strong", { children: e.component }),
        "! Is it configured correctly?"
      ] }) });
    }
    return /* @__PURE__ */ o("div", {});
  }
);
s.displayName = "StoryblokServerComponent";
export {
  s as default
};
